'use client'

import { RefreshRouteOnSave } from '@payloadcms/live-preview-react'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

export function PayloadLivePreview() {
  const router = useRouter()
  const [serverURL] = useState<string | null>(() => 
    typeof window !== 'undefined' ? window.location.origin : null
  )

  if (!serverURL) return null

  return <RefreshRouteOnSave serverURL={serverURL} refresh={() => router.refresh()} />
}

